import { Controller } from "@hotwired/stimulus";

export default class BestInPlaceController extends Controller {
  connect() {
    $(this.element).best_in_place();

    const activator = this.element.dataset.bipActivator;
    if (activator && location.hash === activator) {
      document.querySelector(activator)?.click();
    }

    $(this.element).on("best_in_place:activate", () => {
      $(this).siblings().addClass("editable-hide");
    });

    $(this.element).on("best_in_place:deactivate", () => {
      $(this).siblings().removeClass("editable-hide");
    });

    $(this.element).on("best_in_place:error", (event) => {
      event.preventDefault();
      dataConfirmModal.confirm({
        title: this.element.dataset.title,
        text: this.element.dataset.body,
        commit: this.element.dataset.confirm,
        cancelClass: "d-none",
      });
    });
  }
}
